import styled from "styled-components";

export const Styles = styled.div`
    
    .table {
        border: 1px solid #ddd;
        background-color: #fff;
        font-size: 0.75rem !important;


        @media screen and (max-width: 1200px) {
            font-size: 0.7rem !important;
        }

        @media screen and (max-width: 991px) {
            font-size: 0.68rem !important;
        }

        @media screen and (max-width: 575px) {
            font-size: 0.62rem !important;
        }

        .tr {
            :last-child {
            .td {
                border-bottom: 0;
            }
            }
        }

        .th,
        .td {
            padding: 5px;
            border-bottom: 1px solid #ddd;
            border-right: 1px solid #ddd;
            background-color: #fff;
            overflow: hidden;

            @media screen and (max-width: 1200px) {
                padding: 4px;
            }

            @media screen and (max-width: 991px) {
                padding: 3px;
            }

            @media screen and (max-width: 575px) {
                padding: 2px;
            }

            .resizer {
            display: inline-block;
            width: 5px;
            height: 100%;
            position: absolute;
            right: 0;
            top: 0;
            transform: translateX(50%);
            z-index: 1;

            &.isResizing {
                background: red;
            }
        }
    }

    &.sticky {
        overflow: scroll;
        .header,
        .footer {
            position: sticky;
            z-index: 1;
            width: fit-content;
        }

        .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
        }

        .footer {
        bottom: 0;
        box-shadow: 0px -3px 3px #ccc;
        }

        .body {
        position: relative;
        z-index: 0;
        }

        [data-sticky-td] {
        position: sticky;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        &.wrap-text [data-sticky-td] {
        white-space: normal;
        word-break: break-word;
        text-overflow: unset;
        }

        [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
        }

        [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
        }

        [data-sticky-td] button {
            width: 100% !important;
            min-width: 0 !important;
            max-width: 100%;
            padding-left: 2px !important;
            padding-right: 2px !important;
        }

        [data-sticky-td] .MuiButton-label {
            display: block !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    }
`;